$(document).ready(function () {
    jQuery(function ($) {
        $("#addNewBadge").on("click", function () {
            var formData = new FormData();
            formData.append("action", "getNewBadgeHtmlAjax");
            formData.append("achievementUpdateNonce", achievementObject.achievementUpdateNonce);
            var ajaxForm = new AjaxForm(formData);
            ajaxForm.call(function (ajaxResponseData) {
                if (ajaxResponseData.success) {
                    $("#badgeList").append(ajaxResponseData.message);
                }
            });
        });

        $("#submitAchievement").on("click", function (eventObject) {
            eventObject.preventDefault();
            $("#submitAchievement").text("Saving...");
            if (!$("#submitAchievement").hasClass("disabled")) {
                $("#submitAchievement").addClass("disabled");
                var formElement = $("#badgeForm")[0];
                var formData = new FormData(formElement);
                formData.append("action", "updateAchievement");
                formData.append("achievementUpdateNonce", achievementObject.achievementUpdateNonce);
                var ajaxForm = new AjaxForm(formData);
                ajaxForm.call(function (ajaxResponseData) {
                    if (ajaxResponseData.success) {
                        $("#submitAchievement").text("Save");
                        $("#submitAchievement").removeClass("disabled");
                        console.log(ajaxResponseData);
                    }
                });
            }
        });

        $("#badgeList").on("click", ".close-badge", function () {
            $(this).closest("li").remove();
        });
    });




});


